import React, { useState, useEffect } from "react";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import Paging from "../../components/includes/Paging";
import BranchSearch from "../../components/branchs/BranchSearch";
import BranchSearchResult from "../../components/branchs/BranchSearchResult";
import {LoginAfterCheckLogin,isNull,ChangeMobileFormat} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

//센터관리
const BranchList = () => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //컬럼기본
  let columnList = [
      {Header:'번호',accessor:'nums',width:50},
      {Header:'센터코드',accessor:'bh_code',width:90},
      {Header:'센터명',accessor:'bh_company',width:150},
      {Header:'운영',accessor:'bh_state',width:100},
      {Header:'마마몽떼 로얄티',accessor:'rym_name',width:80},
      {Header:'플라이 로얄티',accessor:'ryf_name',width:60},
      {Header:'대표자명',accessor:'bh_name',width:90},
      {Header:'계정',accessor:'bh_id',width:90},
      {Header:'업태',accessor:'biz_name',width:100},
      {Header:'사업자등록번호',accessor:'bh_biz_code',width:110},
      {Header:'전화',accessor:'bh_mobile',width:130},
      {Header:'이메일',accessor:'bh_email',width:150},
      {Header:'주소',accessor:'bh_address',width:200},
      {Header:'고유번호',accessor:'bh_idx',width:20}
  ];
  const [varColumnLists,setColumnLists] = useState([]);

  //센터 목록
  const [varBranchLists,setBranchLists] = useState([]);

  //검색
  const [varSearchData, setSearchData] = useState({
    searchOption:'all',
    searchString:''
  });

  //페이지
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);
  
  //부운영자 목록 읽어오기
  const getBranchList = async () => {
    const sendData = {pageNum: varPageNum,pageSize: varPageSize,searchData: varSearchData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_branch_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setTotalCount(datas.totalcount);
        let newArray = [];
        const pmax = datas.totalcount - (varPageNum - 1) * varPageSize;
        if(pmax > 0) {
          const dataArray = datas.results;
          for(var i=0; i < dataArray.length; i++) {
            const lineObj = dataArray[i];
            var newData = {};
            newData['nums'] = pmax - i;
            newData['bh_code'] = lineObj.bh_code;
            newData['bh_company'] = lineObj.bh_company;
            newData['bh_state'] = lineObj.bh_status===-1?"가맹신청중":lineObj.bh_status===1?"정상운영중":"휴원";
            newData['rym_name'] = lineObj.rym_name;
            newData['ryf_name'] = lineObj.ryf_name;
            newData['bh_name'] = lineObj.bh_name;
            newData['bh_id'] = lineObj.bh_id;
            newData['biz_name'] = lineObj.biz_name;
            newData['bh_biz_code'] = lineObj.bh_biz_code;
            newData['bh_mobile'] = ChangeMobileFormat(lineObj.bh_mobile);
            newData['bh_email'] = lineObj.bh_email;
            newData['bh_address'] = lineObj.bh_addr1;
            if(!isNull(lineObj.bh_addr2)) newData['bh_address'] += ' '+lineObj.bh_addr2;
            newData['bh_idx'] = lineObj.bh_idx;
            newArray.push(newData);
          }
        }
        console.log(newArray);
        setBranchLists(newArray);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'BRANCH',item:'Branches'});
    console.log(varAdminMenus);
    setColumnLists(columnList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getBranchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum,varSearchData]);

  return varColumnLists.length===0?null:(
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={"센터 관리"} varDirection={'센터 관리'}/>
      <div className="admin-content">
        <BranchSearch varSearchData={varSearchData} setSearchData={setSearchData} setPageNum={setPageNum}/>
        <BranchSearchResult varTotalCount={varTotalCount} varColumnLists={varColumnLists}
                varBranchLists={varBranchLists} getBranchList={getBranchList} varSearchData={varSearchData}/>
        <div className="paging" style={{ marginBottom: "20px" }}>
          <Paging totalCount={varTotalCount} pageSize={varPageSize} curPage={varPageNum} setPage={setPageNum} />
        </div>
      </div>
    </div>
  );
}
export default BranchList;